import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../axiosInstance";

const useGetGuestList = ({ chatId, enabled = true }) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const getData = useCallback(() => {
    const baseUrl = window.localStorage.getItem("BaseURL");
    const endpoint = `/services/projectmanagement/api/guest-groups?eventId=${chatId}`;
    const fullUrl = baseUrl + endpoint;

    return new Promise((resolve, reject) => {
      axiosInstance
        .get(fullUrl)
        .then((res) => {
          setData(res.data);
          resolve(res.data);
        })
        .catch(() => {
          setData(null);
        })
        .finally(() => {
          setLoading(false);
        });
    });
  }, [chatId]);

  useEffect(() => {
    if (!enabled) return;
    getData();
  }, [getData, chatId, enabled]);

  return { data, loading, getData };
};

export default useGetGuestList;
